var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerfilMen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.169,
    height: 61.169,
    viewBox: "0 0 61.169 61.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Perfil_Men\\xFA",
    "data-name": "Perfil Men\\xFA",
    d: "M30.584.563A30.584,30.584,0,1,0,61.169,31.147,30.579,30.579,0,0,0,30.584.563Zm0,11.839A10.853,10.853,0,1,1,19.732,23.254,10.853,10.853,0,0,1,30.584,12.4Zm0,42.424a23.632,23.632,0,0,1-18.067-8.411A13.75,13.75,0,0,1,24.665,39.04a3.018,3.018,0,0,1,.876.136,16.328,16.328,0,0,0,5.044.851,16.266,16.266,0,0,0,5.044-.851,3.018,3.018,0,0,1,.876-.136,13.75,13.75,0,0,1,12.147,7.375A23.632,23.632,0,0,1,30.584,54.825Z",
    transform: "translate(0 -0.563)",
    fill: "#224a8d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfilMen);
export default __webpack_public_path__ + "static/media/Perfil Menú.790f378ead0131260af7b3353b76effe.svg";
export { ForwardRef as ReactComponent };